import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import Sidebar from '../../components/sidebars/Sidebar_staff';
import TopNav from '../../components/top_bars/TopNav_staff';
import StatisticsCards from '../../components/top_bars/StatisticsCard';

const PhoneChecker = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [chartData, setChartData] = useState([]);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/chart_data.php`)
   
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          // Format the response to fit Recharts: rename department -> name, convert staff_count to number
          const formatted = data.data.map((item) => ({
            name: item.department,
            value: Number(item.staff_count),
          }));
          setChartData(formatted);
        }
      })
      .catch((err) => {
        console.error('Error fetching chart data:', err);
      });
  }, []);

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          maxWidth: '1400px',
          mx: 'auto',
          width: '100%',
        }}
      >
        <TopNav
          onLogout={() => {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userProfile');
            localStorage.removeItem('phoneNumber');
          }}
          onNotificationClick={() => alert('You have new notifications!')}
          toggleSidebar={toggleSidebar}
        />

        <Box sx={{ mt: 2 }}>
          <StatisticsCards />
        </Box>

        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                borderRadius: 4,
                width: '100%',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Staff Distribution by Department
              </Typography>

              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Line type="monotone" dataKey="value" stroke="#1976d2" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PhoneChecker;
